import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const vehicleTypeLocaleModule: LocaleModule = {
  name: "vehicleType",
  messages: { en: en, it: it },
};
